import qe, { useState as N, useCallback as pe, useRef as Ye, useEffect as Er } from "react";
import { StyleSheet as ne, TouchableOpacity as Ke, Text as V, View as L, Pressable as ze, TextInput as Tr } from "react-native-web";
import { createPortal as Cr } from "react-dom";
var te = { exports: {} }, G = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Me;
function _r() {
  if (Me) return G;
  Me = 1;
  var x = qe, d = Symbol.for("react.element"), R = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, l = x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, S = { key: !0, ref: !0, __self: !0, __source: !0 };
  function E(k, f, w) {
    var b, T = {}, C = null, O = null;
    w !== void 0 && (C = "" + w), f.key !== void 0 && (C = "" + f.key), f.ref !== void 0 && (O = f.ref);
    for (b in f) m.call(f, b) && !S.hasOwnProperty(b) && (T[b] = f[b]);
    if (k && k.defaultProps) for (b in f = k.defaultProps, f) T[b] === void 0 && (T[b] = f[b]);
    return { $$typeof: d, type: k, key: C, ref: O, props: T, _owner: l.current };
  }
  return G.Fragment = R, G.jsx = E, G.jsxs = E, G;
}
var X = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ue;
function Sr() {
  return Ue || (Ue = 1, process.env.NODE_ENV !== "production" && function() {
    var x = qe, d = Symbol.for("react.element"), R = Symbol.for("react.portal"), m = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), S = Symbol.for("react.profiler"), E = Symbol.for("react.provider"), k = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), F = Symbol.iterator, I = "@@iterator";
    function A(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = F && e[F] || e[I];
      return typeof r == "function" ? r : null;
    }
    var D = x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        oe("error", e, t);
      }
    }
    function oe(e, r, t) {
      {
        var n = D.ReactDebugCurrentFrame, s = n.getStackAddendum();
        s !== "" && (r += "%s", t = t.concat([s]));
        var u = t.map(function(a) {
          return String(a);
        });
        u.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, u);
      }
    }
    var ae = !1, ie = !1, J = !1, se = !1, le = !1, i;
    i = Symbol.for("react.module.reference");
    function P(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === m || e === S || le || e === l || e === w || e === b || se || e === O || ae || ie || J || typeof e == "object" && e !== null && (e.$$typeof === C || e.$$typeof === T || e.$$typeof === E || e.$$typeof === k || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === i || e.getModuleId !== void 0));
    }
    function W(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var s = r.displayName || r.name || "";
      return s !== "" ? t + "(" + s + ")" : t;
    }
    function H(e) {
      return e.displayName || "Context";
    }
    function $(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case m:
          return "Fragment";
        case R:
          return "Portal";
        case S:
          return "Profiler";
        case l:
          return "StrictMode";
        case w:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case k:
            var r = e;
            return H(r) + ".Consumer";
          case E:
            var t = e;
            return H(t._context) + ".Provider";
          case f:
            return W(e, e.render, "ForwardRef");
          case T:
            var n = e.displayName || null;
            return n !== null ? n : $(e.type) || "Memo";
          case C: {
            var s = e, u = s._payload, a = s._init;
            try {
              return $(a(u));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Y = Object.assign, q = 0, me, xe, Re, we, Ee, Te, Ce;
    function _e() {
    }
    _e.__reactDisabledLog = !0;
    function Ge() {
      {
        if (q === 0) {
          me = console.log, xe = console.info, Re = console.warn, we = console.error, Ee = console.group, Te = console.groupCollapsed, Ce = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: _e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        q++;
      }
    }
    function Xe() {
      {
        if (q--, q === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Y({}, e, {
              value: me
            }),
            info: Y({}, e, {
              value: xe
            }),
            warn: Y({}, e, {
              value: Re
            }),
            error: Y({}, e, {
              value: we
            }),
            group: Y({}, e, {
              value: Ee
            }),
            groupCollapsed: Y({}, e, {
              value: Te
            }),
            groupEnd: Y({}, e, {
              value: Ce
            })
          });
        }
        q < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ue = D.ReactCurrentDispatcher, ce;
    function Z(e, r, t) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (s) {
            var n = s.stack.trim().match(/\n( *(at )?)/);
            ce = n && n[1] || "";
          }
        return `
` + ce + e;
      }
    }
    var de = !1, Q;
    {
      var Ze = typeof WeakMap == "function" ? WeakMap : Map;
      Q = new Ze();
    }
    function Se(e, r) {
      if (!e || de)
        return "";
      {
        var t = Q.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      de = !0;
      var s = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var u;
      u = ue.current, ue.current = null, Ge();
      try {
        if (r) {
          var a = function() {
            throw Error();
          };
          if (Object.defineProperty(a.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(a, []);
            } catch (j) {
              n = j;
            }
            Reflect.construct(e, [], a);
          } else {
            try {
              a.call();
            } catch (j) {
              n = j;
            }
            e.call(a.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (j) {
            n = j;
          }
          e();
        }
      } catch (j) {
        if (j && n && typeof j.stack == "string") {
          for (var o = j.stack.split(`
`), _ = n.stack.split(`
`), h = o.length - 1, v = _.length - 1; h >= 1 && v >= 0 && o[h] !== _[v]; )
            v--;
          for (; h >= 1 && v >= 0; h--, v--)
            if (o[h] !== _[v]) {
              if (h !== 1 || v !== 1)
                do
                  if (h--, v--, v < 0 || o[h] !== _[v]) {
                    var B = `
` + o[h].replace(" at new ", " at ");
                    return e.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", e.displayName)), typeof e == "function" && Q.set(e, B), B;
                  }
                while (h >= 1 && v >= 0);
              break;
            }
        }
      } finally {
        de = !1, ue.current = u, Xe(), Error.prepareStackTrace = s;
      }
      var U = e ? e.displayName || e.name : "", z = U ? Z(U) : "";
      return typeof e == "function" && Q.set(e, z), z;
    }
    function Qe(e, r, t) {
      return Se(e, !1);
    }
    function er(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function ee(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Se(e, er(e));
      if (typeof e == "string")
        return Z(e);
      switch (e) {
        case w:
          return Z("Suspense");
        case b:
          return Z("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return Qe(e.render);
          case T:
            return ee(e.type, r, t);
          case C: {
            var n = e, s = n._payload, u = n._init;
            try {
              return ee(u(s), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var K = Object.prototype.hasOwnProperty, je = {}, ke = D.ReactDebugCurrentFrame;
    function re(e) {
      if (e) {
        var r = e._owner, t = ee(e.type, e._source, r ? r.type : null);
        ke.setExtraStackFrame(t);
      } else
        ke.setExtraStackFrame(null);
    }
    function rr(e, r, t, n, s) {
      {
        var u = Function.call.bind(K);
        for (var a in e)
          if (u(e, a)) {
            var o = void 0;
            try {
              if (typeof e[a] != "function") {
                var _ = Error((n || "React class") + ": " + t + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              o = e[a](r, a, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (h) {
              o = h;
            }
            o && !(o instanceof Error) && (re(s), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, a, typeof o), re(null)), o instanceof Error && !(o.message in je) && (je[o.message] = !0, re(s), y("Failed %s type: %s", t, o.message), re(null));
          }
      }
    }
    var tr = Array.isArray;
    function fe(e) {
      return tr(e);
    }
    function nr(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function or(e) {
      try {
        return Oe(e), !1;
      } catch {
        return !0;
      }
    }
    function Oe(e) {
      return "" + e;
    }
    function Be(e) {
      if (or(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nr(e)), Oe(e);
    }
    var De = D.ReactCurrentOwner, ar = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pe, Fe;
    function ir(e) {
      if (K.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function sr(e) {
      if (K.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function lr(e, r) {
      typeof e.ref == "string" && De.current;
    }
    function ur(e, r) {
      {
        var t = function() {
          Pe || (Pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function cr(e, r) {
      {
        var t = function() {
          Fe || (Fe = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var dr = function(e, r, t, n, s, u, a) {
      var o = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: d,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: a,
        // Record the component responsible for creating this element.
        _owner: u
      };
      return o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(o, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(o, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    };
    function fr(e, r, t, n, s) {
      {
        var u, a = {}, o = null, _ = null;
        t !== void 0 && (Be(t), o = "" + t), sr(r) && (Be(r.key), o = "" + r.key), ir(r) && (_ = r.ref, lr(r, s));
        for (u in r)
          K.call(r, u) && !ar.hasOwnProperty(u) && (a[u] = r[u]);
        if (e && e.defaultProps) {
          var h = e.defaultProps;
          for (u in h)
            a[u] === void 0 && (a[u] = h[u]);
        }
        if (o || _) {
          var v = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          o && ur(a, v), _ && cr(a, v);
        }
        return dr(e, o, _, s, n, De.current, a);
      }
    }
    var be = D.ReactCurrentOwner, Ie = D.ReactDebugCurrentFrame;
    function M(e) {
      if (e) {
        var r = e._owner, t = ee(e.type, e._source, r ? r.type : null);
        Ie.setExtraStackFrame(t);
      } else
        Ie.setExtraStackFrame(null);
    }
    var he;
    he = !1;
    function ve(e) {
      return typeof e == "object" && e !== null && e.$$typeof === d;
    }
    function Ae() {
      {
        if (be.current) {
          var e = $(be.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function br(e) {
      return "";
    }
    var We = {};
    function hr(e) {
      {
        var r = Ae();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function $e(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = hr(r);
        if (We[t])
          return;
        We[t] = !0;
        var n = "";
        e && e._owner && e._owner !== be.current && (n = " It was passed a child from " + $(e._owner.type) + "."), M(e), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), M(null);
      }
    }
    function Le(e, r) {
      {
        if (typeof e != "object")
          return;
        if (fe(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            ve(n) && $e(n, r);
          }
        else if (ve(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var s = A(e);
          if (typeof s == "function" && s !== e.entries)
            for (var u = s.call(e), a; !(a = u.next()).done; )
              ve(a.value) && $e(a.value, r);
        }
      }
    }
    function vr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === T))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = $(r);
          rr(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !he) {
          he = !0;
          var s = $(r);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", s || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function gr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            M(e), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), M(null);
            break;
          }
        }
        e.ref !== null && (M(e), y("Invalid attribute `ref` supplied to `React.Fragment`."), M(null));
      }
    }
    var Ve = {};
    function He(e, r, t, n, s, u) {
      {
        var a = P(e);
        if (!a) {
          var o = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = br();
          _ ? o += _ : o += Ae();
          var h;
          e === null ? h = "null" : fe(e) ? h = "array" : e !== void 0 && e.$$typeof === d ? (h = "<" + ($(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : h = typeof e, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", h, o);
        }
        var v = fr(e, r, t, s, u);
        if (v == null)
          return v;
        if (a) {
          var B = r.children;
          if (B !== void 0)
            if (n)
              if (fe(B)) {
                for (var U = 0; U < B.length; U++)
                  Le(B[U], e);
                Object.freeze && Object.freeze(B);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Le(B, e);
        }
        if (K.call(r, "key")) {
          var z = $(e), j = Object.keys(r).filter(function(wr) {
            return wr !== "key";
          }), ge = j.length > 0 ? "{key: someKey, " + j.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ve[z + ge]) {
            var Rr = j.length > 0 ? "{" + j.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ge, z, Rr, z), Ve[z + ge] = !0;
          }
        }
        return e === m ? gr(v) : vr(v), v;
      }
    }
    function pr(e, r, t) {
      return He(e, r, t, !0);
    }
    function yr(e, r, t) {
      return He(e, r, t, !1);
    }
    var mr = yr, xr = pr;
    X.Fragment = m, X.jsx = mr, X.jsxs = xr;
  }()), X;
}
var Ne;
function jr() {
  return Ne || (Ne = 1, process.env.NODE_ENV === "production" ? te.exports = _r() : te.exports = Sr()), te.exports;
}
var c = jr();
const Dr = ({ onPress: x, text: d, variant: R = "primary", style: m, disabled: l = !1 }) => {
  const [S, E] = N(!1), k = pe(() => {
    l || E(!0);
  }, [l]), f = pe(() => E(!1), []), w = pe(() => {
    !l && x && x();
  }, [l, x]), b = () => {
    switch (R) {
      case "secondary":
        return {
          button: g.greyBtn,
          buttonHovered: g.greyBtnHovered,
          buttonDisabled: g.greyBtnDisabled,
          text: g.greyBtnText,
          textDisabled: g.greyBtnTextDisabled
        };
      case "tertiary":
        return {
          button: g.lightBlueBtn,
          buttonHovered: g.lightBlueBtnHovered,
          buttonDisabled: g.lightBlueBtnDisabled,
          text: g.lightBlueBtnText,
          textDisabled: g.lightBlueBtnTextDisabled
        };
      case "warning":
        return {
          button: g.redBtn,
          buttonHovered: g.redBtnHovered,
          buttonDisabled: g.redBtnDisabled,
          text: g.redBtnText,
          textDisabled: g.redBtnTextDisabled
        };
      default:
        return {
          button: g.blueBtn,
          buttonHovered: g.blueBtnHovered,
          buttonDisabled: g.blueBtnDisabled,
          text: g.blueBtnText,
          textDisabled: g.blueBtnTextDisabled
        };
    }
  }, { button: T, buttonHovered: C, buttonDisabled: O, text: F, textDisabled: I } = b();
  return /* @__PURE__ */ c.jsx(
    Ke,
    {
      style: [
        T,
        !l && S && C,
        l && O,
        m
      ],
      onPress: w,
      onMouseEnter: k,
      onMouseLeave: f,
      disabled: l,
      children: /* @__PURE__ */ c.jsx(V, { style: [F, l && I], children: d })
    }
  );
}, g = ne.create({
  blueBtn: {
    backgroundColor: "#396de0",
    borderRadius: 25,
    padding: 10,
    alignItems: "center",
    justifyContent: "center",
    width: 150,
    transition: "background-color 0.3s ease"
  },
  blueBtnHovered: {
    backgroundColor: "#2a51a8"
  },
  blueBtnText: {
    color: "white",
    fontFamily: "'lato', sans-serif",
    fontWeight: "bold"
  },
  blueBtnDisabled: {
    backgroundColor: "#a8c4e8",
    opacity: 0.6
  },
  blueBtnTextDisabled: {
    color: "#e8e8e8"
  },
  greyBtn: {
    backgroundColor: "#f0f0f0",
    borderRadius: 25,
    padding: 10,
    alignItems: "center",
    justifyContent: "center",
    width: 150,
    transition: "background-color 0.3s ease"
  },
  greyBtnHovered: {
    backgroundColor: "#e0e0e0"
  },
  greyBtnText: {
    color: "#737373",
    fontFamily: "'lato', sans-serif",
    fontWeight: "bold"
  },
  greyBtnDisabled: {
    backgroundColor: "#f8f8f8",
    opacity: 0.6
  },
  greyBtnTextDisabled: {
    color: "#b8b8b8"
  },
  lightBlueBtn: {
    backgroundColor: "#e6f2ff",
    borderRadius: 25,
    padding: 10,
    alignItems: "center",
    justifyContent: "center",
    width: 150,
    transition: "background-color 0.3s ease"
  },
  lightBlueBtnHovered: {
    backgroundColor: "#d1e6ff"
  },
  lightBlueBtnText: {
    color: "#396de0",
    fontFamily: "'lato', sans-serif",
    fontWeight: "bold"
  },
  lightBlueBtnDisabled: {
    backgroundColor: "#f5f9ff",
    opacity: 0.6
  },
  lightBlueBtnTextDisabled: {
    color: "#a8c4e8"
  },
  redBtn: {
    backgroundColor: "#e03939",
    borderRadius: 25,
    padding: 10,
    alignItems: "center",
    justifyContent: "center",
    width: 150,
    transition: "background-color 0.3s ease"
  },
  redBtnHovered: {
    backgroundColor: "#e8b5b5"
  },
  redBtnText: {
    color: "white",
    fontFamily: "'lato', sans-serif",
    fontWeight: "bold"
  },
  redBtnDisabled: {
    backgroundColor: "#f0b8b8",
    opacity: 0.6
  },
  redBtnTextDisabled: {
    color: "#f8e8e8"
  }
}), Pr = ({
  label: x,
  value: d = "",
  options: R = [],
  onChange: m,
  multiSelect: l = !1,
  enableSearch: S = !1,
  placeholder: E = "Select...",
  searchPlaceholder: k = "Search...",
  noResultsText: f = "No results found"
}) => {
  const [w, b] = N(!1), [T, C] = N(""), [O, F] = N({ top: 0, left: 0, width: 0 }), I = Ye(null), A = Ye(null), D = S ? R.filter(
    (i) => i.toLowerCase().includes(T.toLowerCase())
  ) : R, y = (i) => {
    m(i), b(!1), C("");
  }, oe = (i) => {
    const P = Array.isArray(d) ? d : [], W = P.includes(i) ? P.filter((H) => H !== i) : [...P, i];
    m(W);
  }, ae = () => {
    m([]);
  }, ie = () => {
    if (l) {
      const i = Array.isArray(d) ? d : [];
      return i.length === 0 ? E : i.length === 1 ? i[0] : `${i.length} items selected`;
    } else
      return d || E;
  }, J = () => {
    if (A.current) {
      const i = A.current.getBoundingClientRect();
      F({
        top: i.bottom + window.scrollY,
        left: i.left + window.scrollX,
        width: i.width
      });
    }
  }, se = () => {
    w || J(), b(!w);
  };
  Er(() => {
    const i = (H) => {
      I.current && !I.current.contains(H.target) && A.current && !A.current.contains(H.target) && (b(!1), C(""));
    }, P = () => {
      w && J();
    }, W = () => {
      w && J();
    };
    return document.addEventListener("mousedown", i), window.addEventListener("scroll", P, !0), window.addEventListener("resize", W), () => {
      document.removeEventListener("mousedown", i), window.removeEventListener("scroll", P, !0), window.removeEventListener("resize", W);
    };
  }, [w]);
  const le = () => w ? Cr(
    /* @__PURE__ */ c.jsxs(L, { style: [p.dropdown, {
      position: "absolute",
      top: O.top,
      left: O.left,
      width: O.width,
      zIndex: 999999
    }], ref: I, children: [
      S && /* @__PURE__ */ c.jsx(L, { style: p.searchContainer, children: /* @__PURE__ */ c.jsx(
        "input",
        {
          type: "text",
          placeholder: k,
          value: T,
          onChange: (i) => C(i.target.value),
          style: p.searchInput
        }
      ) }),
      l && /* @__PURE__ */ c.jsx(L, { style: p.controlsRow, children: /* @__PURE__ */ c.jsx(
        Ke,
        {
          style: p.clearFilterButton,
          onPress: ae,
          children: /* @__PURE__ */ c.jsx(V, { style: p.clearFilterText, children: "Clear Filter" })
        }
      ) }),
      /* @__PURE__ */ c.jsxs(L, { style: p.optionsContainer, children: [
        D.map((i) => {
          const P = l ? Array.isArray(d) ? d.includes(i) : !1 : d === i;
          return /* @__PURE__ */ c.jsxs(
            ze,
            {
              style: ({ hovered: W }) => [
                p.option,
                l && p.checkboxOption,
                W && p.optionHovered
              ],
              onPress: () => l ? oe(i) : y(i),
              children: [
                l && /* @__PURE__ */ c.jsx(L, { style: p.checkbox, children: P && /* @__PURE__ */ c.jsx(V, { style: p.checkmark, children: "✓" }) }),
                /* @__PURE__ */ c.jsx(V, { style: [
                  p.optionText,
                  P && !l && p.selectedOptionText
                ], children: i })
              ]
            },
            i
          );
        }),
        D.length === 0 && /* @__PURE__ */ c.jsx(V, { style: p.noResults, children: f })
      ] })
    ] }),
    document.body
  ) : null;
  return /* @__PURE__ */ c.jsxs(L, { style: p.container, children: [
    x && /* @__PURE__ */ c.jsx(V, { style: p.label, children: x }),
    /* @__PURE__ */ c.jsxs(
      ze,
      {
        ref: A,
        style: p.dropdownButton,
        onPress: se,
        accessibilityLabel: `Open ${x} dropdown`,
        children: [
          /* @__PURE__ */ c.jsx(V, { style: p.dropdownButtonText, children: ie() }),
          /* @__PURE__ */ c.jsx(L, { style: p.indicatorSeparator }),
          /* @__PURE__ */ c.jsx(
            "svg",
            {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              style: { position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" },
              children: /* @__PURE__ */ c.jsx(
                "path",
                {
                  d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z",
                  fill: "#999"
                }
              )
            }
          )
        ]
      }
    ),
    le()
  ] });
}, p = ne.create({
  container: {
    flexDirection: "column",
    marginRight: 20,
    marginBottom: 10,
    minWidth: 200,
    position: "relative",
    zIndex: 1e3
  },
  label: {
    color: "#396de0",
    fontWeight: "bold",
    fontFamily: "'lato', sans-serif",
    fontSize: 16,
    marginBottom: 5
  },
  dropdownButton: {
    backgroundColor: "#f3f4f6",
    border: "1px solid #d1d5db",
    borderRadius: 8,
    paddingLeft: 12,
    paddingRight: 36,
    minWidth: 120,
    height: 45,
    fontFamily: "'lato', sans-serif",
    fontSize: 16,
    cursor: "pointer",
    position: "relative",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    boxShadow: "none",
    transition: "border-color 0.15s ease-in-out"
  },
  dropdownButtonText: {
    color: "#374151",
    fontFamily: "'lato', sans-serif",
    fontSize: 16
  },
  indicatorSeparator: {
    position: "absolute",
    right: 32,
    top: "50%",
    transform: "translateY(-50%)",
    height: 24,
    width: 1,
    backgroundColor: "#d1d5db"
  },
  dropdown: {
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "#b8cbf5",
    borderRadius: 5,
    maxHeight: 300,
    zIndex: 999999,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 9999,
    overflow: "hidden"
  },
  searchContainer: {
    borderBottomWidth: 1,
    borderBottomColor: "#e5e7eb",
    padding: 8
  },
  searchInput: {
    width: "100%",
    padding: 6,
    borderRadius: 3,
    border: "1px solid #d1d5db",
    fontFamily: "'lato', sans-serif",
    fontSize: 16,
    outlineStyle: "none",
    color: "#396de0",
    boxSizing: "border-box"
  },
  controlsRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#e5e7eb",
    backgroundColor: "#f9fafb"
  },
  clearFilterButton: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignItems: "center"
  },
  clearFilterText: {
    color: "#dc2626",
    fontFamily: "'lato', sans-serif",
    fontSize: 16,
    fontWeight: "600"
  },
  optionsContainer: {
    maxHeight: 300,
    overflow: "auto"
  },
  option: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 12,
    cursor: "pointer",
    transition: "background-color 0.15s ease",
    outlineStyle: "none",
    borderWidth: 0
  },
  optionHovered: {
    backgroundColor: "#e6f2ff"
  },
  checkboxOption: {
    paddingVertical: 6
  },
  checkbox: {
    width: 16,
    height: 16,
    borderWidth: 1,
    borderColor: "#d1d5db",
    borderRadius: 3,
    marginRight: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white"
  },
  checkmark: {
    color: "#396de0",
    fontSize: 16,
    fontWeight: "bold",
    lineHeight: 14
  },
  optionText: {
    color: "#374151",
    fontFamily: "'lato', sans-serif",
    fontSize: 16,
    flex: 1
  },
  selectedOptionText: {
    color: "#396de0",
    fontWeight: "600"
  },
  noResults: {
    color: "#9ca3af",
    fontFamily: "'lato', sans-serif",
    fontSize: 16,
    fontStyle: "italic",
    textAlign: "center",
    paddingVertical: 16
  }
}), Fr = ({
  value: x,
  onChangeText: d,
  onBlur: R,
  onFocus: m,
  onSubmit: l,
  placeholder: S,
  multiline: E = !1,
  maxLength: k,
  autoFocus: f = !1,
  editable: w = !0,
  style: b,
  testID: T,
  ...C
}) => {
  const [O, F] = N(!1), I = (y) => {
    F(!0), m == null || m();
  }, A = (y) => {
    F(!1), R == null || R();
  }, D = () => {
    l == null || l();
  };
  return /* @__PURE__ */ c.jsx(
    Tr,
    {
      value: x,
      onChangeText: d,
      onFocus: I,
      onBlur: A,
      onSubmitEditing: D,
      placeholder: S,
      placeholderTextColor: "#a6a6a6",
      multiline: E,
      maxLength: k,
      autoFocus: f,
      editable: w,
      testID: T,
      style: [
        ye.base,
        O && ye.focused,
        E && ye.multiline,
        b
      ],
      ...C
    }
  );
}, ye = ne.create({
  base: {
    fontSize: 16,
    fontFamily: "'lato', sans-serif",
    borderRadius: 8,
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
    borderWidth: 1,
    borderColor: "#d1d5db",
    backgroundColor: "#f3f4f6",
    color: "#000",
    transition: "border-color 0.2s ease",
    outlineStyle: "none"
  },
  focused: {
    borderColor: "#396de0"
  },
  multiline: {
    minHeight: 120,
    textAlignVertical: "top"
  }
}), Ir = ({ label: x, children: d, style: R }) => /* @__PURE__ */ c.jsxs(L, { style: [Je.container, R], children: [
  /* @__PURE__ */ c.jsx(V, { style: Je.label, children: x }),
  d
] }), Je = ne.create({
  container: {
    flexDirection: "column",
    marginBottom: 10
  },
  label: {
    color: "#396de0",
    fontWeight: "bold",
    fontFamily: "'lato', sans-serif",
    fontSize: 14,
    marginBottom: 5
  }
}), Ar = (x, d) => {
  const [R, m] = N(x), l = (E) => {
    m(E);
  }, S = () => {
    d(R);
  };
  return {
    value: R,
    onChangeText: l,
    onBlur: S,
    onSubmit: S
  };
}, Wr = "1.0.0";
export {
  Dr as Button,
  Pr as Dropdown,
  Ir as FormField,
  Fr as TextInput,
  Ar as useSearchInput,
  Wr as version
};
